import { PaymentButton } from '@/modules/perseo-billing/components';
import { GiftCardBalanceMessage } from '@/modules/perseo-billing/containers/payment-methods/components/gift-card/applied-gift-card/gift-card-balance-message.component';
import { GiftCardPaymentLabel } from '@/modules/perseo-billing/containers/payment-methods/components/gift-card/applied-gift-card/gift-card-payment-label.component';
import { SubmittedGiftCardPreview } from '@/modules/perseo-billing/containers/payment-methods/components/gift-card/submitted-gift-card-preview.component';
import { useGiftCardData } from '@/modules/perseo-billing/hooks/use-gift-card-data';
import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src';

export const GiftCardDetails = () => {
  const isMobile = useMediaQuery('lg');

  if (!isMobile) return <DesktopView />;
  return <MobileView />;
};

const MobileView = () => {
  const { getGiftCardBalance } = useGiftCardData();
  const giftCardBalance = getGiftCardBalance();

  const hasBalance = giftCardBalance > 0;

  return (
    <div className={'co-flex co-flex-col co-gap-8px co-justify-between'}>
      {hasBalance && (
        <div className="co-w-full co-flex co-flex-col">
          <GiftCardBalanceMessage />
        </div>
      )}

      <div className="co-flex co-flex-col co-items-start co-gap-6 co-w-full">
        <SubmittedGiftCardPreview />
      </div>
    </div>
  );
};

const DesktopView = () => {
  const { getGiftCardAmount, getGiftCardBalance } = useGiftCardData();

  const totalGiftCard = getGiftCardAmount();
  const giftCardBalance = getGiftCardBalance();

  const hasBalance = giftCardBalance > 0;

  return (
    <div className="co-flex co-flex-col co-gap-4 co-justify-between">
      <div className="co-flex co-gap-8px co-justify-between">
        {hasBalance && (
          <div className="co-w-full co-flex co-flex-col co-justify-between xl:co-w-2/4">
            <GiftCardBalanceMessage />
          </div>
        )}
        <div className="co-flex co-flex-col co-items-start co-gap-6 co-w-full xl:co-w-2/4">
          <SubmittedGiftCardPreview />
        </div>
      </div>

      <div className="co-flex co-flex-row co-gap-8px">
        <div className="co-flex co-w-full">
          <GiftCardPaymentLabel />
        </div>
        <div className="co-flex co-w-full">
          <PaymentButton
            method="GIFT_CARD"
            disabled={totalGiftCard === 0}
            className="co-w-full"
          />
        </div>
      </div>
    </div>
  );
};
